import React, { useState } from 'react';
import { Select, Tabs } from 'antd';
import RegularEmployee from './RegularEmployee/RegularEmployee';
import { ArrowLeftOutlined } from '@ant-design/icons';
import { Link } from 'react-router-dom';
const { TabPane } = Tabs;
const { Option } = Select;

const SalaryStructure = () => {
    const [activeTabKey, setActiveTabKey] = useState('1');
    const [organization, setOrganization] = useState('cnw');

    const items = [
        {
            key: '1',
            label: 'Regular Employee',
            children: <RegularEmployee activeTabKey={activeTabKey} organization={organization} />,
        },
        {
            key: '2',
            label: 'Intern',
            children: <RegularEmployee activeTabKey={activeTabKey} organization={organization} />,
        },
    ]
    const handleTabChange = (key: string) => {

        setActiveTabKey(key);
    };
    return (
        <div className='page-container bg-customBg'>
            <div className="full-width-container">
                <div className="py-5 flex items-center justify-between">
                    <h1 className='organization_title flex items-center'>
                        <Link to='/home/dashboard'>
                            <span className='organization_back-arrow pr-4 hover:text-black'>
                                <ArrowLeftOutlined />
                            </span>
                        </Link>
                        Salary Structure
                    </h1>
                </div>
                <Tabs
                    activeKey={activeTabKey}
                    onChange={handleTabChange}
                    tabBarExtraContent={
                        <div className="flex items-center gap-2"> <p className="text-md m-0 font-bold">Select Organization :</p>
                            <Select value={organization} onChange={(value) => setOrganization(value)} placeholder="Select Organisation" className="min-w-[200px]" >
                                <Option value="cnw">CloudNow</Option>
                                <Option value="krissco">Krissco</Option>
                            </Select>
                        </div>
                    }
                >
                    {items.map(item => (
                        <TabPane key={item.key} tab={item.label}>
                            {item.children}
                        </TabPane>
                    ))}
                </Tabs>
            </div>
        </div>

    )
}

export default SalaryStructure;
